import React from "react";
import {
    Box,
    Button,
    Modal,
    Typography,
    IconButton,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Styles from '../Config/Styles'


const ModalBox = ({ open, handleClose, handleSubmit, file, handleFileDrop, handleFileInput, handleDelete }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Styles.ModalContent >
                <Styles.Header>
                    <Typography variant="h6" sx={Styles.rfq.typo}>
                        Raise RFQ by Document
                    </Typography>
                </Styles.Header>
                <Box sx={Styles.rfq.dragbox}>
                    <Styles.DragDropArea
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleFileDrop}
                    >
                        <IconButton>
                            <AttachFileIcon sx={Styles.rfq.attach} />
                        </IconButton>
                        <Typography variant="body1" color="#0047A4">
                            Drag or Drop an Image or Select a File
                        </Typography>
                        <Typography variant="caption" color="#0047A4">
                            PDF, EXCEL, JPG, PNG
                        </Typography>
                        <input
                            type="file"
                            onChange={handleFileInput}
                            style={Styles.rfq.input}
                        />
                    </Styles.DragDropArea>
                    {file && <Box sx={Styles.rfq.filebox}>
                        <Typography>{file?.name}</Typography>
                        <IconButton onClick={handleDelete}><DeleteOutlineOutlinedIcon sx={Styles.rfq.icon} /></IconButton>
                    </Box>}
                    <Box sx={Styles.rfq.btnbox}>
                        <Button variant="outlined" onClick={handleClose} sx={Styles.rfq.backbtn}>
                            Back
                        </Button>
                        <Button
                            sx={Styles.rfq.confirmbtn}
                            variant="contained"
                            disabled={!file}
                            onClick={handleSubmit}
                        >
                            Confirm
                        </Button>
                    </Box>

                </Box>
            </Styles.ModalContent>
        </Modal>
    );
};

export default ModalBox;
